import makeStyles from '@mui/styles/makeStyles';
const radioGroupStyles = makeStyles(() => ({
    root: {},
    radioGroup: {},
    row: {},
    item: {},
    itemChecked: {},
    itemDisabled: {},
    itemRoot: {},
    label: {},
}), { name: 'RadioGroup' });
export default radioGroupStyles;
//# sourceMappingURL=radioGroup.styles.js.map